module.exports = __webpack_public_path__ + "img/italy-digestive-diseases-male.4333d46d.png";